import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ChatBubbleOvalLeftIcon } from '@heroicons/react/24/outline';

import type { CommunityComment } from '~/interfaces/community/comment';
import { ReactionPicker } from '~/routes/community/_components/PostCard/_components/ReactionPicker';

interface CommentActionsProps {
  comment: CommunityComment;
  canReply: boolean;
  onToggleReply: () => void;
}

const actionButtonClass = 'flex items-center gap-1 rounded-full px-2 py-1 transition-colors hover:bg-black/5';

export const CommentActions: FC<CommentActionsProps> = ({ comment, canReply, onToggleReply }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-8 pt-1">
      <ReactionPicker
        reactableType="CommunityPostComment"
        reactableId={comment.id}
        reactionsCount={comment.reactions_count}
        memberReactions={comment.current_member_reactions}
      />

      {canReply && (
        <button
          type="button"
          onClick={onToggleReply}
          className={actionButtonClass}
          aria-label={t('community.comments.reply')}
        >
          <ChatBubbleOvalLeftIcon className="size-4 text-black/50" />
        </button>
      )}
    </div>
  );
};
